// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2UTDe","navbar__list":"Navbar_navbar__list__XVcx5","navbar__list__item":"Navbar_navbar__list__item__Z5eYc"};